export const USER_NAME_CHARACTERS_LIMIT = 30;
